<div class="identification-detail-page">

    @if (isLoading) {
  
      <div class="loading-state">
        Cargando información de la placa...
      </div>
  
    } @else if (!identification) {
  
      <div class="empty-state">
  
        <div class="empty-icon">
          🏷️
        </div>
  
        <h2>No se encontró la placa</h2>
  
        <p>
          La placa solicitada no existe o ya no está disponible.
        </p>
  
        <button
          type="button"
          class="back-button"
          (click)="goBack()"
        >
          Volver a placas
        </button>
  
      </div>
  
    } @else {
  
      <div class="detail-header">
  
        <button
          type="button"
          class="back-link"
          (click)="goBack()"
        >
          ← Volver a placas
        </button>
  
        <div class="header-content">
  
          <div class="animal-heading">
  
            <div class="animal-icon">
  
              @if (identification.species === 'DOG') {
                🐶
              } @else {
                🐱
              }
  
            </div>
  
            <div>
  
              <h1>
                {{ identification.animalName }}
              </h1>
  
              <span>
                @if (identification.species === 'DOG') {
                  Perro
                } @else {
                  Gato
                }
              </span>
  
            </div>
  
          </div>
  
  
          <span
            class="status-badge"
            [class.status-completed]="
              identification.status === 'COMPLETED'
            "
            [class.status-pending]="
              identification.status === 'PENDING'
            "
          >
  
            @if (identification.status === 'COMPLETED') {
              Completada
            } @else {
              Pendiente
            }
  
          </span>
  
        </div>
  
      </div>
  
  
      <div class="detail-grid">
  
        <section class="detail-card">
  
          <div class="card-title">
  
            <div class="title-icon">
              👤
            </div>
  
            <div>
              <h2>Información del responsable</h2>
  
              <p>
                Datos de contacto de la persona responsable.
              </p>
            </div>
  
          </div>
  
  
          <div class="information-grid">
  
            <div class="information-item">
  
              <span>
                Responsable
              </span>
  
              <strong>
                {{ identification.responsibleName }}
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Teléfono
              </span>
  
              <strong>
                {{ identification.phone || 'Sin registrar' }}
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Vinculado por
              </span>
  
              <strong>
                {{ identification.linkerName }}
              </strong>
  
            </div>

            <div class="information-item">
                <span>
                  Estudiante de Servicio Social
                </span>
              
                <strong>
                  {{ identification.studentRef?.nombreCompleto || identification.linkerName }}
                </strong>
              </div>
              
              <div class="information-item">
                <span>
                  Matrícula
                </span>
              
                <strong>
                  {{ identification.studentRef?.matricula || 'Sin registrar' }}
                </strong>
              </div>
  
          </div>
  
        </section>
  
  
        <section class="detail-card">
  
          <div class="card-title">
  
            <div class="title-icon">
              🏷️
            </div>
  
            <div>
              <h2>Información de la placa</h2>
  
              <p>
                Características de la placa solicitada.
              </p>
            </div>
  
          </div>
  
  
          <div class="information-grid">
  
            <div class="information-item">
  
              <span>
                Diseño
              </span>
  
              <strong>
                {{ identification.plateDesign || 'Sin especificar' }}
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Material
              </span>
  
              <strong>
  
                @if (identification.material === 'STEEL') {
                  Acero
                } @else {
                  Aluminio
                }
  
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Especie
              </span>
  
              <strong>
  
                @if (identification.species === 'DOG') {
                  Perro
                } @else {
                  Gato
                }
  
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Nombre del animal
              </span>
  
              <strong>
                {{ identification.animalName }}
              </strong>
  
            </div>
  
          </div>
  
        </section>
  
  
        <section class="detail-card">
  
          <div class="card-title">
  
            <div class="title-icon">
              💰
            </div>
  
            <div>
              <h2>Información económica</h2>
  
              <p>
                Costos registrados para la placa.
              </p>
            </div>
  
          </div>
  
  
          <div class="cost-grid">
  
            <div class="cost-item">
  
              <span>
                Costo ABAQ
              </span>
  
              <strong>
                ${{ identification.abaqCost || 0 }}
              </strong>
  
            </div>
  
  
            <div class="cost-item">
  
              <span>
                Costo proveedor
              </span>
  
              <strong>
                ${{ identification.providerCost || 0 }}
              </strong>
  
            </div>
  
          </div>
  
        </section>
  
  
        <section class="detail-card">
  
          <div class="card-title">
  
            <div class="title-icon">
              📎
            </div>
  
            <div>
              <h2>Comprobante de pago</h2>
  
              <p>
                Evidencia del pago realizado.
              </p>
            </div>
  
          </div>
  
  
          @if (identification.paymentProofUrl) {
  
            <a
              [href]="identification.paymentProofUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="evidence-link"
            >
              🔗 Ver comprobante de pago
            </a>
  
          } @else {
  
            <div class="no-evidence">
              No se ha agregado un comprobante de pago.
            </div>
  
          }
  
        </section>
  
  
        <section class="detail-card">
  
          <div class="card-title">
  
            <div class="title-icon">
              📅
            </div>
  
            <div>
              <h2>Registro</h2>
  
              <p>
                Información del registro en ABAQ.
              </p>
            </div>
  
          </div>
  
  
          <div class="information-grid">
  
            <div class="information-item">
  
              <span>
                Fecha de registro
              </span>
  
              <strong>
                {{ identification.createdAt | date:'mediumDate':'UTC' }}
              </strong>
  
            </div>
  
  
            <div class="information-item">
  
              <span>
                Última actualización
              </span>
  
              <strong>
                {{ identification.updatedAt | date:'mediumDate':'UTC' }}
              </strong>
  
            </div>
  
          </div>
  
        </section>
  
  
        @if (identification.status === 'PENDING') {
  
          <section class="status-card">
  
            <div>
  
              <h2>
                Actualizar estado
              </h2>
  
              <p>
                Marca la placa como completada cuando
                el proceso haya terminado.
              </p>
  
            </div>
  
  
            <button
              type="button"
              class="complete-button"
              (click)="updateStatus('COMPLETED')"
              [disabled]="isUpdatingStatus"
            >
  
              @if (isUpdatingStatus) {
                Actualizando...
              } @else {
                ✓ Marcar como completada
              }
  
            </button>
  
          </section>
  
        } @else {
  
          <section class="completed-card">
  
            <div class="completed-icon">
              ✓
            </div>
  
            <div>
  
              <h2>
                Placa completada
              </h2>
  
              <p>
                Esta placa ya fue marcada como completada.
              </p>
  
            </div>
  
          </section>
  
        }
  
      </div>
  
    }
  
  </div>